import type { RefObject } from 'react';
import { useMemo } from 'react';

import type { ColumnFiltersState } from '@tanstack/react-table';

import { SHOW_SELECTED_URL_PARAM } from '@/config/constants';
import type { SymbolKey } from '@/entities/symbol';
import {
  energyTransitionModules,
  FILTER_KEYS,
  NEW_DATA_URL_PARAM,
  oilOnlyModules
} from '../constants';
import type { FilterState } from '../types/filter.types';

export const useCatalogColumnFilters = ({
  filters,
  showDiscontinued,
  frozenSymbolsRef
}: {
  filters: FilterState;
  showDiscontinued: boolean;
  frozenSymbolsRef: RefObject<SymbolKey[]>;
}): ColumnFiltersState => {
  const showSelected = filters[SHOW_SELECTED_URL_PARAM];
  const only = filters.only;

  return useMemo((): ColumnFiltersState => {
    const result: ColumnFiltersState = [
      { id: 'Status', value: showDiscontinued },
      { id: 'Code', value: showSelected ? frozenSymbolsRef.current : [] },
      { id: 'LaunchDate', value: filters[NEW_DATA_URL_PARAM] }
    ];

    for (const key of Object.values(FILTER_KEYS)) {
      if (key === FILTER_KEYS.INDEX_MODULE) continue;
      const value = filters[key as keyof typeof filters];
      if (value && typeof value === 'string') {
        result.push({ id: key, value: [value] });
      }
    }

    const indexModuleValue = filters[FILTER_KEYS.INDEX_MODULE];
    if (indexModuleValue) {
      result.push({ id: 'IndexModule', value: [indexModuleValue] });
    } else if (only === 'oil') {
      result.push({ id: 'IndexModule', value: oilOnlyModules });
    } else if (only === 'energyTransition') {
      result.push({ id: 'IndexModule', value: energyTransitionModules });
    }

    return result;
    // frozenSymbolsRef is a stable ref — reads .current at memo time, not a dep
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, showSelected, only, showDiscontinued]);
};
